import React, { useState } from 'react';
import imagenHome from '../../images/banner_principal.png';
import logoNav from '../../images/logo-visa.png';

export const Banner = () => {
	return (

		<div className="hero">
			<div className="nav">
                <img src={logoNav} alt="Liverpool Visa logo" />
			</div>
			<div className="portada">
				<img src={imagenHome} alt="Liverpool Visa logo" />
				<div className="informacion">
				</div>
			</div>
		</div>

		
	);
	
};

